import Dexie from "dexie";
import db from "../Db";

var DeleteDefuntS = Dexie.async(function* () {
  yield db.open();
  yield db.DEFUNT_S.clear();
});

export default DeleteDefuntS;
